
export class AssetBundleFileInfo {
    public static classType = m4m["AssetBundleFileInfo"] = AssetBundleFileInfo;
    public fileName: string = "";
    public length: number = 0;
    public guid: string = "";
    // tslint:disable-next-line: variable-name
    public zip_length: number = 0;
    public oldVersions: boolean = false;
    public name: string = "";

}
